
import { defineComponent } from 'vue';
import BotoesEdicao from '../../../comum/BotoesEdicao.vue';
import { TextoEditavel } from '@/dominio/editor/questoes/comum/texto/TextoEditavel';

export default defineComponent({
    name: 'TextoVisualizacao',
    components: { BotoesEdicao },
    props: {
        texto: { type: TextoEditavel, required: true },
        ehPrimeiro: { type: Boolean, required: true },
        ehUltimo: { type: Boolean, required: true },
    },
    computed: {
        titulo() {
            let titulo = this.texto.toString();
            if (titulo.length > 28) {
                titulo = titulo.substring(0, 25) + '...';
            }
            return titulo;
        },
    },
    methods: {
        editar() {
            this.$emit('editar', this.texto);
        },
        excluir() {
            this.$emit('excluir', this.texto);
        },
        descer() {
            this.$emit('descer', this.texto);
        },
        subir() {
            this.$emit('subir', this.texto);
        },
    },
    emits: ['excluir', 'descer', 'subir', 'editar'],
});
